export default __webpack_public_path__ + "static/media/join_logo.fb1514ad.png";